export const GENDERS = [
  {
    key: 'female',
    name: 'Femenino'
  },
  {
    key: 'male',
    name: 'Masculino'
  },
  {
    key: 'other',
    name: 'Otro'
  }
]
